module.exports = "/fast-coin/fonts/proxima-nova-semibold.otf";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/fonts/proxima-nova-semibold.otf
// module id = 2265
// module chunks = 5